import React from 'react';
import { Button, H1, TextLg } from 'atoms';
import { useDispatchUi } from 'context/ui';
import Image from '@/components/ReusableUI/Image';

interface Props {
    heading?: string;
    subhead?: string;
    img?: any;
    ctalink?: string;
    ctalabel?: string;
    videoLink?: any;
    children?: React.ReactNode;
}

export const Hero = ({ heading, subhead, img, ctalabel, children = null }: Props) => {
    const dispatch: any = useDispatchUi();
    return (
        <div id='parents-hero'>
            <div id='parents-hero-content'>
                <div id='parents-hero-left'>
                    <div style={{ width: '100%' }}>
                        <Image image={img} />
                        {/*<img style={{ width: '100%' }} src={img.url} />*/}
                    </div>
                </div>
                <div id='parents-hero-right'>
                    <H1 pb={5}>{heading}</H1>
                    <TextLg textVariant='light'>{subhead}</TextLg>
                    {ctalabel && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                mt={5}
                                // Href={ctalink}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch({ type: 'OPEN_MODAL' });
                                }}
                            >
                                {ctalabel}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            {children}
            <style jsx>
                {`
                    #parents-hero {
                        position: relative;
                        padding: 88px 60px 0px 60px;
                        background: linear-gradient(180deg, #f1f7f9 0%, #daeaf9 100%);
                    }

                    #parents-hero-content {
                        margin: 0 auto;
                        max-width: 1280px;
                        display: flex;
                        align-items: center;
                    }

                    #parents-hero-left {
                        width: 100%;
                        padding-right: 40px;
                    }

                    #parents-hero-right {
                        width: 100%;
                    }

                    @media (max-width: 992px) {
                        #parents-hero {
                            padding: 80px 40px 80px 40px;
                        }

                        #parents-hero-content {
                            flex-direction: column-reverse;
                        }

                        #parents-hero-left {
                            padding-right: 0px;
                        }

                        #parents-hero-right {
                            width: 100%;
                            padding: 48px 0px 16px 0px;
                        }

                        #watch-video {
                            display: none;
                        }
                    }

                    @media (max-width: 480px) {
                        #parents-hero {
                            padding: 80px 20px 48px 20px;
                        }
                    }
                `}
            </style>
        </div>
    );
};
